<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-table ref="table" :columns="columns" :api="api" :default-params="defaultParams">
      <template #type="row">
        <div>{{ divvyCategory[row.data.type] }}</div>
      </template>
      <template #divideType="row">
        <div>{{ divvyModes[row.data.divideType] }}</div>
      </template>
      <template #operation="row">
        <el-button type="primary" size="mini" @click="handleEdit(row.data)">编辑</el-button>
        <el-button type="danger" size="mini" @click="handleDel(row.data)">删除</el-button>
      </template>
    </com-table>
    <divvy-edit ref="createdType" @update="update"></divvy-edit>
  </com-page>
</template>

<script>
import { divvySettingListApi, deleteDivvySettingApi } from '@/api/community'
import DivvyEdit from './divvy-edit'

export default {
  components: { DivvyEdit },
  props: {
    communityCode: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      api: divvySettingListApi,
      defaultParams: {},
      searchColumns: [
        {
          label: '分成人',
          prop: 'refPartnerName',
          type: 'input'
        }
      ],
      columns: [
        {
          label: '分成人',
          prop: 'refPartnerName'
        },
        {
          label: '分成类别',
          prop: 'type',
          type: 'slot',
          slotName: 'type',
        },
        {
          label: '分成方式',
          prop: 'divideType',
          type: 'slot',
          slotName: 'divideType',
        },
        {
          label: '分成比例（%）',
          prop: 'divide'
        },
        {
          label: '生效时间',
          prop: 'effectiveTime',
          width: '120px'
        },
        {
          label: '有效期至',
          prop: 'expireTime',
          width: '120px'
        },
        {
          label: '创建人',
          prop: 'refCreateUserName'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          width: '120px'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: '180px'
        }
      ],

      divvyCategory: {
        1: '合伙人',
        2: '商家',
        3: '代理商',
      },

      divvyModes: {
        1: '营业额分成',
        2: '服务费分成',
        3: '充值分成',
        4: '套餐卡分成'
      }
    }
  },
  created() {
    console.log('this.defaultParams :>> ', this.defaultParams)
    this.defaultParams.refResidentialArea = this.communityCode
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        communityCode: this.communityCode,
        row
      }
      this.$refs.createdType.open(params)
    },
    handleCreated() {
      const params = {
        type: 'created',
        communityCode: this.communityCode
      }
      this.$refs.createdType.open(params)
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleDel(row) {
      this.$confirm('是否确认删除该设置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          deleteDivvySettingApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.search_wrapper {
  width: 100%;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
